import React, { useEffect, useState } from "react";
import { auth, db } from "../../utilities/firebaseConfig";
import { ref, onValue, update, get } from "firebase/database";
import timeicon from "../../assets/ttime.svg";
import calendericon from "../../assets/tcalendar.svg";
import TechnicianDashboardLayout from "../../components/TechnicianDashboardLayout";
import ClickOutsideWrapper from "../../components/ClickOutSideWrapper";
import { useNavigate } from "react-router-dom";
import TechnicianVeri from "../../components/TechnicianNotVerified";
import PricingLayout from "../../components/PricingLayout";

const TechnicianDashboard = () => {
  const navigate = useNavigate();
  const [isModalOpen, setModalOpen] = useState(true);
  const [isPmodalOpen, setIsPmodalOpen] = useState(true);
  const [online, setOnline] = useState(false);
  const [btnactive, setBtnActive] = useState("All tasks");
  const [activeJobs, setActiveJobs] = useState([]);
  const [show, setShow] = useState(false);
  const [showorientation, setShowOrientation] = useState("grid");
  const [sortam, setSortam] = useState("all");
  const [showSort, setShowSort] = useState(false);
  const [technician, setTechnician] = useState(null);

  useEffect(() => {
    const user = auth.currentUser;
    if (!user) {
      navigate("/");
      return;
    }

    const technicianId = auth.currentUser ? auth.currentUser.uid : null;
    if (!technicianId) return;

    // Fetch technician details
    const technicianRef = ref(db, `technicians/${user.uid}`);
    onValue(technicianRef, (snapshot) => {
      if (snapshot.exists()) {
        const techData = snapshot.val();
        setTechnician(techData);
        setOnline(techData.online);
      }
    });
  }, [navigate]);

  useEffect(() => {
    const fetchActiveJobs = () => {
      const user = auth.currentUser;
      if (!user) {
        return;
      }

      const jobsRef = ref(db, "jobs");
      onValue(jobsRef, async (snapshot) => {
        if (snapshot.exists()) {
          const jobsData = Object.entries(snapshot.val()).map(([id, job]) => ({
            id,
            ...job,
          }));

          // Filter for jobs that belong to the current user.
          let filteredJobs = jobsData.filter(
            (job) => job.technicianId === user.uid
          );

          filteredJobs = filteredJobs.filter(
            (job) => job.status !== "completed" && job.status !== "cancelled"
          );

          // ✅ Handle the filtering logic based on `sortam`
          if (sortam === "all") {
            // Show everything except pending
            filteredJobs = filteredJobs.filter(
              (job) => job.status !== "pending"
            );
          } else {
            // Show only the selected status (including "pending")
            filteredJobs = filteredJobs.filter((job) => job.status === sortam);
          }

          // For each filtered job, fetch the technician details (if technicianId exists).
          const jobsWithTechDetails = await Promise.all(
            filteredJobs.map(async (job) => {
              if (job.technicianId) {
                const techRef = ref(db, `technicians/${job.technicianId}`);
                const techSnapshot = await get(techRef);
                if (techSnapshot.exists()) {
                  return { ...job, technician: techSnapshot.val() };
                }
              }
              return job;
            })
          );

          setActiveJobs(jobsWithTechDetails);
        } else {
          setActiveJobs([]);
        }
      });
    };

    fetchActiveJobs();
  }, [sortam]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(false); // Hide modal after 3 seconds
    }, 3000);

    return () => clearTimeout(timer); // Cleanup on unmount
  }, [show]);
  // Do not render modal if hidden

  const acceptTask = (taskId) => {
    update(ref(db, `jobs/${taskId}`), {
      status: "accepted",
      acceptedDate: Date.now(),
      acceptedtechname: technician.name,
      acceptedtechlastname: technician.lastName,
    });
    setShow(true);
  };

  const rejectTask = (taskId) => {
    update(ref(db, `jobs/${taskId}`), {
      status: "rejected",
      rejectedDate: Date.now(),
      rejectedtechname: technician.name,
      rejectedtechlastname: technician.lastName,
    });
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    // Arrays for the short names of days and months.
    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    // Get the components of the date.
    const dayName = days[date.getDay()];
    const monthName = months[date.getMonth()];
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();

    return `${dayName}, ${monthName} ${day}, ${year}`;
  }

  const navlinkstas = [
    {
      id: 0,
      name: "New tasks",
      link: "pending",
    },
    {
      id: 1,
      name: "All tasks",
      link: "all",
    },
  ];

  const sortlist = [
    {
      id: 0,
      name: "all",
    },
    {
      id: 1,
      name: "in progress",
    },
    {
      id: 2,
      name: "accepted",
    },
    {
      id: 3,
      name: "completed",
    },
    {
      id: 4,
      name: "cancelled",
    },
    {
      id: 5,
      name: "rejected",
    },
  ];

  const formatWhatsAppTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();

    const diffInMs = now - date;
    const diffInSeconds = Math.floor(diffInMs / 1000);
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    const diffInHours = Math.floor(diffInMinutes / 60);
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
    const diffInWeeks = Math.floor(diffInDays / 7);
    const yearDiff = now.getFullYear() - date.getFullYear();
    const monthDiff = now.getMonth() - date.getMonth() + yearDiff * 12;

    const isToday = date.toDateString() === now.toDateString();

    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);
    const isYesterday = date.toDateString() === yesterday.toDateString();

    if (diffInSeconds < 60) {
      return "Just now";
    } else if (isToday) {
      return "Today";
    } else if (isYesterday) {
      return "Yesterday";
    } else if (diffInDays < 7) {
      return `${diffInDays} day${diffInDays > 1 ? "s" : ""} ago`;
    } else if (diffInWeeks < 4) {
      return `${diffInWeeks} week${diffInWeeks > 1 ? "s" : ""} ago`;
    } else if (monthDiff >= 1) {
      return `${monthDiff} month${monthDiff > 1 ? "s" : ""} ago`;
    } else {
      return date.toLocaleDateString(undefined, {
        weekday: "short",
        month: "short",
        day: "numeric",
        year: "numeric",
      });
    }
  };

  const handletheclick = (job) => {
    if (job.status === "pending") {
      return;
    } else {
      navigate(`/technician/task_details/${job.id}`);
    }
  };

  return (
    <>
      <TechnicianDashboardLayout>
        <div className='theclientdsh'>
          <div className='theclientdasnav'>
            <div className='theclientdasleft'>
              {navlinkstas.map((link, index) => (
                <button
                  className={`
                             ${
                               btnactive === link.name
                                 ? "activebtn"
                                 : "notactivebtn"
                             } theclientbtnnav`}
                  key={link.id}
                  onClick={() => {
                    setBtnActive(link.name);
                    setSortam(link.link);
                  }}
                >
                  {link.name}
                </button>
              ))}
            </div>
            <div className='theclientdashright'>
              <button
                className='thcligrid'
                onClick={() => setShowOrientation("grid")}
              >
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  viewBox='0 0 24 24'
                  width='18'
                  height='18'
                  fill={showorientation === "grid" ? "#ff6250" : "#3b3b3b"}
                >
                  <path d='M21 3C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM11 13H4V19H11V13ZM20 13H13V19H20V13ZM11 5H4V11H11V5ZM20 5H13V11H20V5Z'></path>
                </svg>
              </button>
              <button
                className='thclilist'
                onClick={() => setShowOrientation("list")}
              >
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  viewBox='0 0 24 24'
                  width='18'
                  height='18'
                  fill={showorientation === "list" ? "#ff6250" : "#3b3b3b"}
                >
                  <path d='M11 4H21V6H11V4ZM11 8H17V10H11V8ZM11 14H21V16H11V14ZM11 18H17V20H11V18ZM3 4H9V10H3V4ZM5 6V8H7V6H5ZM3 14H9V20H3V14ZM5 16V18H7V16H5Z'></path>
                </svg>
              </button>
              {btnactive !== "New tasks" && (
                <div className='thcdropsam'>
                  <button className='thcdrop' onClick={() => setShowSort(true)}>
                    <label htmlFor=''>{sortam}</label>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      viewBox='0 0 24 24'
                      width='36'
                      height='36'
                      fill='currentColor'
                    >
                      <path d='M12 14L8 10H16L12 14Z'></path>
                    </svg>
                  </button>
                  {showSort && (
                    <ClickOutsideWrapper
                      onClickOutside={() => setShowSort(false)}
                    >
                      <div className='sortfrcasn'>
                        {sortlist.map((sort, index) => (
                          <button
                            onClick={() => {
                              setSortam(sort.name);
                              setShowSort(false);
                            }}
                            id={sort.id}
                            className={`thesortshow ${
                              sortam === sort.name
                                ? "thesortshowactive"
                                : "thesortshownotactive"
                            }`}
                          >
                            {sort.name}
                          </button>
                        ))}
                      </div>
                    </ClickOutsideWrapper>
                  )}
                </div>
              )}
            </div>
          </div>
          <div className='thespac'></div>
          {showorientation === "grid" && (
            <div className='thetasklistcnt'>
              {activeJobs.length > 0 ? (
                activeJobs.map((job) => (
                  <div key={job.id} className='activetaskcnttop hover-wrapper'>
                    <div className='hover-overlay'>
                      <div className='activetaskcntdnae'></div>
                      {job.status === "pending" ? (
                        <div className='taskpropsbtn'>
                          <button
                            className='tpbaccept'
                            onClick={() => acceptTask(job.id)}
                          >
                            Accept
                          </button>
                          <button
                            className='tpbdecline'
                            onClick={() => rejectTask(job.id)}
                          >
                            Decline
                          </button>
                        </div>
                      ) : (
                        <button
                          onClick={() =>
                            navigate(`/technician/task_details/${job.id}`)
                          }
                          className='select-button'
                        >
                          Select Task
                        </button>
                      )}
                    </div>
                    <div className='activetaskcnt'>
                      <div className='activetaskcntleft'>
                        <p className='jobtitle'>{job.jobtitle}</p>
                        <div className='thegap'></div>
                        <div className='btsdetitemm'>
                          <img
                            src={calendericon}
                            alt=''
                            className='btsdeticonn'
                          />
                          <label htmlFor='' className='btsdettlabell'>
                            {formatDate(job.date)}
                          </label>
                        </div>
                        {/* <div className='btsdetitemm'>
                        <img
                          src={locationicon}
                          alt=''
                          className='btsdeticonn'
                        />
                        <label htmlFor='' className='btsdettlabell'>
                          {job.address}
                        </label>
                      </div> */}
                        <div className='btsdetitemm'>
                          <img src={timeicon} alt='' className='btsdeticonn' />
                          <label htmlFor='' className='btsdettlabell'>
                            {job.timeOfDay}
                          </label>
                        </div>
                      </div>
                      <div className='thegap'></div>
                    </div>
                    <div className='thegap'></div>
                    {/* <button
                    className='mytaskviewtbtnn'
                    onClick={() => navigate(`/job/${job.id}`)}
                  >
                    View Details
                  </button> */}
                    <div className='activecrateat'>
                      <p> {formatWhatsAppTimestamp(job.createdAt)}</p>
                      <p className='acdivestat'>{job.status}</p>
                    </div>
                  </div>
                ))
              ) : (
                <p>You have no {sortam} jobs.</p>
              )}
            </div>
          )}
          {showorientation === "list" && (
            <div>
              {activeJobs.length > 0 ? (
                activeJobs.map((job) => (
                  <div
                    key={job.id}
                    className='thelasliksns'
                    onClick={() => handletheclick(job)}
                  >
                    <h1 className='thelasjotit'>{job.jobtitle}</h1>
                    <p className='tehlasdes'>{job.jobdescription}</p>
                    <div className='teshimgname'>
                      {job.status === "pending" && (
                        <div className='taskpropsbtn'>
                          <button
                            className='tpbaccept'
                            onClick={() => acceptTask(job.id)}
                          >
                            Accept
                          </button>
                          <button
                            className='tpbdecline'
                            onClick={() => rejectTask(job.id)}
                          >
                            Decline
                          </button>
                        </div>
                      )}
                    </div>
                    <p className='tablesta'>{job.status}</p>
                    <p className='tabletimsa'>
                      {formatWhatsAppTimestamp(job.createdAt)}
                    </p>
                  </div>
                ))
              ) : (
                <p>You have no {sortam} jobs.</p>
              )}
            </div>
          )}
        </div>
      </TechnicianDashboardLayout>

      {technician?.bio && (
        <TechnicianVeri
          isOpen={isModalOpen}
          onClose={() => setModalOpen(false)}
        />
      )}
      {technician?.pricing && (
        <PricingLayout
          isOpen={isPmodalOpen}
          onClose={() => setIsPmodalOpen(false)}
        />
      )}
    </>
  );
};

export default TechnicianDashboard;
